import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TableColumn } from '@app/shared';
import { NZ_DRAWER_DATA, NzDrawerRef } from 'ng-zorro-antd/drawer';

@Component({
  selector: 'app-master-form-drawer',
  standalone: false,
  templateUrl: './master-form-drawer.component.html',
  styleUrl: './master-form-drawer.component.less',
})
export class MasterFormDrawerComponent implements OnInit {
  nzData: {
    columnsData: TableColumn[];
    maestroName: string;
    defaultValues?: Record<string, any>;
  } = inject(NZ_DRAWER_DATA);

  @Output() createEvent = new EventEmitter<any>();

  dynamicForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private drawerRef: NzDrawerRef<string>,
  ) {}

  ngOnInit(): void {
    const formGroupConfig: { [key: string]: any } = {};

    this.nzData.columnsData.forEach((column) => {
      const fieldName = column.pathData?.name;
      if (!fieldName || fieldName === 'id') {
        return;
      }

      const validators = column.validators?.map((validator) => validator.function) || [];
      let defaultValue =
        this.nzData.defaultValues?.[fieldName] !== undefined
          ? this.nzData.defaultValues[fieldName]
          : column.defaultValue;

      if (defaultValue === undefined) {
        if (column.pathData?.type === 'boolean') {
          defaultValue = false;
        } else if (column.pathData?.type === 'select' && column.optionList?.length) {
          defaultValue = column.optionList[0].id;
        } else if (column.pathData?.type === 'number') {
          defaultValue = 0;
        } else {
          defaultValue = '';
        }
      }

      formGroupConfig[fieldName] = [defaultValue, validators];
    });

    this.dynamicForm = this.fb.group(formGroupConfig);
  }

  getValidatorError(column: TableColumn): string {
    return column.validators?.[0]?.message || 'Este campo es requerido';
  }

  hasOptions(column: TableColumn): boolean {
    return !!column.optionList?.length;
  }

  isRequired(column: TableColumn): boolean {
    return !!column.validators?.some((validator) => validator.error === 'required');
  }

  close(): void {
    this.drawerRef.close();
  }

  create(): void {
    if (this.dynamicForm.invalid) {
      Object.values(this.dynamicForm.controls).forEach((control) => {
        control.markAsDirty();
        control.updateValueAndValidity({ onlySelf: true });
      });
      return;
    }

    this.createEvent.emit(this.dynamicForm.getRawValue());
  }
}
